import { getDateISOBasedInEndOfBusinessDay } from './chunk-PHOCK55S.mjs';
import { DateTime } from 'luxon';

var getDatesByReportPeriodCore = (period, state) => {
  let luxonToday = DateTime.now().toUTC();
  const luxonTodayWithEndOfBusinessDay = DateTime.fromISO(
    getDateISOBasedInEndOfBusinessDay(luxonToday.toFormat("yyyy/MM/dd"), state)
  ).toUTC();
  if (luxonToday < luxonTodayWithEndOfBusinessDay) {
    luxonToday = luxonToday.minus({ day: 1 });
  }
  switch (period) {
    case "today" /* TODAY */:
      return {
        startDate: luxonToday.toFormat("yyyy/MM/dd"),
        endDate: luxonToday.plus({ days: 1 }).toFormat("yyyy/MM/dd")
      };
    case "yesterday" /* YESTERDAY */:
      return {
        startDate: luxonToday.minus({ days: 1 }).toFormat("yyyy/MM/dd"),
        endDate: luxonToday.toFormat("yyyy/MM/dd")
      };
    case "this_week" /* THIS_WEEK */:
      return {
        startDate: luxonToday.startOf("week").toFormat("yyyy/MM/dd"),
        endDate: luxonToday.plus({ days: 1 }).toFormat("yyyy/MM/dd")
      };
    case "this_month" /* THIS_MONTH */:
      return {
        startDate: luxonToday.startOf("month").toFormat("yyyy/MM/dd"),
        endDate: luxonToday.plus({ days: 1 }).toFormat("yyyy/MM/dd")
      };
    case "this_year" /* THIS_YEAR */:
      return {
        startDate: luxonToday.startOf("year").toFormat("yyyy/MM/dd"),
        endDate: luxonToday.plus({ days: 1 }).toFormat("yyyy/MM/dd")
      };
    default:
      return {
        startDate: "",
        endDate: ""
      };
  }
};
var getEmployeesMainScreenRequestFormData = (request, sorting) => {
  const params = [];
  if (request.roleIds) {
    request.roleIds.forEach((roleId) => {
      params.push(`roleIds=${roleId}`);
    });
  }
  if ("currentStatus" in request && request.currentStatus) {
    params.push(`currentStatus=${request.currentStatus}`);
  }
  params.push(`period=${request.period}`);
  params.push(`startDate=${request.startDate}`);
  params.push(`endDate=${request.endDate}`);
  if ("clockedIn" in request) {
    params.push(`clockedIn=${request.clockedIn}`);
  }
  if ("search" in request && request.search) {
    params.push(`search=${request.search}`);
  }
  if ("page" in request) {
    params.push(`page=${request.page}`);
  }
  if (sorting && sorting.field) {
    params.push(`sorting=${sorting.field}`);
  }
  if (sorting && sorting.direction === "desc") {
    params.push("isInverseSorting=true");
  }
  return `?${params.join("&")}`;
};
var getEmployeeDetailsScreenRequestFormData = (request, sorting) => {
  const params = [];
  params.push(`organizationUserId=${request.organizationUserId}`);
  if (sorting && sorting.field) {
    params.push(`sorting=${sorting.field}`);
  }
  if (sorting && sorting.direction === "desc") {
    params.push("isAscending=true");
  }
  return `${getEmployeesMainScreenRequestFormData(request)}&${params.join("&")}`;
};

export { getDatesByReportPeriodCore, getEmployeeDetailsScreenRequestFormData, getEmployeesMainScreenRequestFormData };
